module.exports = __webpack_public_path__ + "img/partner_layout2.891d560f.png";